import { CreditReviewDocument } from 'shared/types/creditReview';

export const creditReviewDocumentsParser = (data: CreditReviewDocument[]) =>
  data.map(({ fileName, link, name }) => ({
    name: fileName,
    title: name,
    /* remove '/api' string from fetched documents path to avoid doubling it */
    path: link.replace('/api', ''),
  }));
